(() => {
  const sticky = document.querySelector('[data-brand-sticky-atc]');
  if (!sticky) return;

  const productInfo = document.querySelector('product-info');
  const mainSubmit = document.querySelector('.product-form__submit[name="add"]');
  const mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
  const stickyButton = sticky.querySelector('[data-brand-sticky-atc-button]');
  const stickySize = sticky.querySelector('[data-brand-sticky-atc-size]');
  const stickyPrice = sticky.querySelector('[data-brand-sticky-atc-price]');
  const stickyLabel = sticky.querySelector('[data-brand-sticky-atc-label]');
  const stickyImage = sticky.querySelector('[data-brand-sticky-atc-image]');

  const normalizeOptionValue = (value) => String(value || '').toLowerCase().replace(/\s+/g, '');

  const toggleSticky = (show) => {
    sticky.toggleAttribute('hidden', !show);
  };

  if (mainSubmit && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        toggleSticky(!entry.isIntersecting);
      },
      { threshold: 0, rootMargin: '0px 0px -8px 0px' }
    );
    observer.observe(mainSubmit);
  }

  stickyButton?.addEventListener('click', () => {
    if (!mainSubmit || mainSubmit.disabled) return;
    mainSubmit.click();
  });

  const syncGiftOffer = (variant) => {
    const offer = document.querySelector('[data-brand-product-gwp-offer]');
    if (!offer) return;

    const qualifyingValue = normalizeOptionValue(offer.dataset.qualifyingValue);
    const activeSize = document.querySelector('[data-brand-product-size]')?.textContent;
    const selectedPickerValues = Array.from(
      document.querySelectorAll('variant-selects input[type="radio"]:checked')
    ).map((input) => input.value);
    const optionValues =
      selectedPickerValues.length > 0
        ? selectedPickerValues
        : [activeSize, variant?.title, variant?.public_title, ...(variant?.options || [])];
    const qualifies = optionValues.some((value) => normalizeOptionValue(value) === qualifyingValue);
    const title = offer.querySelector('[data-brand-product-gwp-offer-title]');

    offer.toggleAttribute('data-qualified', qualifies);
    if (title) {
      title.textContent = qualifies ? offer.dataset.qualifiedMessage : offer.dataset.unqualifiedMessage;
    }
  };

  const syncFromDom = (variant) => {
    const titleSize = document.querySelector('[data-brand-product-size]');
    if (stickySize && titleSize) {
      const text = titleSize.textContent.trim();
      if (text) {
        stickySize.textContent = text;
        stickySize.removeAttribute('hidden');
      } else {
        stickySize.setAttribute('hidden', '');
      }
    }

    if (mainSubmit && stickyButton) {
      stickyButton.disabled = mainSubmit.disabled;
      const mainPrice = mainSubmit.querySelector('.brand-product-submit__price');
      if (stickyPrice && mainPrice) {
        stickyPrice.textContent = mainPrice.textContent.trim();
      }
      if (stickyLabel) {
        const labelText = mainSubmit.querySelector('span')?.childNodes?.[0]?.textContent?.trim();
        if (labelText && !mainSubmit.disabled) {
          stickyLabel.childNodes[0].textContent = `${labelText} `;
        } else if (mainSubmit.disabled) {
          stickyLabel.textContent = mainSubmit.textContent.trim();
        }
      }
    }

    const activeThumb = document.querySelector('.product__media-item.is-active img, .product__media-list .product__media-item:first-child img');
    if (stickyImage && activeThumb?.src) {
      stickyImage.src = activeThumb.src;
      stickyImage.srcset = activeThumb.srcset || '';
    }

    syncGiftOffer(variant);
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => syncFromDom(event?.data?.variant));
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => {
      window.requestAnimationFrame(() => syncGiftOffer());
    });
  }

  productInfo?.addEventListener('product-info:loaded', syncFromDom);
  document.addEventListener('DOMContentLoaded', syncFromDom);
  window.addEventListener('load', syncFromDom);
})();
